/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, {useMemo, useState} from 'react';
import ArgosFlexbox from "../../../components/Containers/ArgosFlexbox";
import TurnRightIcon from '@mui/icons-material/TurnRight';
import {useAppSelector} from "../../../../redux/hooks";
import {selectCurrentUser} from "../../../../redux/ducks/AccessControl/slice";
import {ETrackedItemTypes, TRACKED_ITEMS_ICONS_MAP} from "../../../../constants/trackedItems";

import {Autocomplete, Box, IconButton, TextField} from '@mui/material';
import {selectIsLoadingTrackedItems, selectTrackedItems} from "../../../../redux/ducks/Favorites/slice";

const SearchItems = () => {
  const [selectedItem, setSelectedItem] = useState<any>()
  const gmid = useAppSelector(state => selectCurrentUser(state).id)

  const trackedItems = useAppSelector(selectTrackedItems)
  const lstTrackedItems: any[] = useMemo(() => {
    // tracked items is a map of id to data, we just want flat list of data for the autocomplete options
    return trackedItems ? Object.values(trackedItems) : []
  }, [trackedItems])

  const isLoadingTrackedItems = useAppSelector(selectIsLoadingTrackedItems)

  return (
    <ArgosFlexbox style={{width: '100%', marginTop: 10}}>
      <Autocomplete
        loading={isLoadingTrackedItems}
        data-no-dnd="true"
        disablePortal
        options={lstTrackedItems ?? []}
        sx={{width: '100%'}}
        getOptionLabel={(option: any) => option.label}
        renderOption={(props, option, state) => {
          const icon = TRACKED_ITEMS_ICONS_MAP?.[option.type] ?? TRACKED_ITEMS_ICONS_MAP[ETrackedItemTypes.UNKNOWN]
          return (
            <Box component="li" sx={{'& > *': {marginRight: '5px', flexShrink: 0}}} {...props} key={state.index}>
              {icon}
              {option.label}
            </Box>
          )
        }}
        renderInput={(params) => <TextField {...params} sx={{}} label="Global Search"/>}
        onChange={(event, value: any) => {
          // window.open(value?.url, '_blank')
          setSelectedItem(value)
        }} // prints the selected value
        filterOptions={(options, state) => {
          const inputValue = state.inputValue;
          const filtered = options.filter((v: any) => {
            if (v.label.toLowerCase().includes(inputValue.toLowerCase())) return true
            return false
          })
          return filtered
        }}
      />
      <IconButton data-no-dnd="true" size={'large'} onClick={() => window.open(selectedItem?.url, '_blank')}>
        <TurnRightIcon fontSize={'large'} style={{}}/>
      </IconButton>
    </ArgosFlexbox>
  )
}

export default SearchItems